export default __webpack_public_path__ + "static/media/talent_finder_not_found.74e9be81.svg";